import {Component, OnInit} from '@angular/core';
import {UserService} from '../core/_services/user.service';
import {UtilitiesService} from '../core/_services/utilities.service';
import {MetaService} from '@ngx-meta/core';
import {AuthService} from '../core/_services/auth.service';
import {ActivatedRoute} from '@angular/router';
import {USER_EVENT_TYPE} from "../core/constants";
import {EventTrackingService} from '../core/_services/event-tracking.service';

@Component({
    selector: 'app-unsubscribe',
    templateUrl: './unsubscribe.component.html',
})

export class UnsubscribeComponent implements OnInit {

    contentLoaded = false;
    token = '';
    email = '';
    h1Text = '';
    pText = '';

    constructor(private userService: UserService,
                private eventTrackingService: EventTrackingService,
                private utilitiesService: UtilitiesService,
                private authService: AuthService,
                private route: ActivatedRoute,
                private metaService: MetaService) {
        this.metaService.setTitle('Wrench - Unsubscribe');
    } // constructor()

    ngOnInit() {
        this.route.queryParams.subscribe(params => {

            const user = this.userService.getCurrentUserData();
            if (this.authService.loggedIn() && !this.utilitiesService.isEmpty(user)) {
                this.email = user.email;
                this.unsubscribeUser();
            } else if (!this.utilitiesService.isEmpty(params) && !this.utilitiesService.isEmpty(params.t)) {
                this.token = params.t;
                this.email = this.authService.getEmailFromToken(this.token);
                this.unsubscribeUser();
            } else {
                this.contentLoaded = true;
                this.responseCode(false);
                let trackParams = {
                    type: USER_EVENT_TYPE.UNSUBSCRIBE.value,
                    name: USER_EVENT_TYPE.UNSUBSCRIBE.label,
                    ga: {action: 'unsubscribe from marketing emails', properties: {category: "email unsubscribe", label: "error - no parameters"}},
                    internal: {
                        endpoint: '',
                        endpointParams: ''
                    }
                };
                this.eventTrackingService.trackEvent(trackParams);
                return;
            }
        });

    } // ngOnInit()

    responseCode(response: any) {
        if (response) {
            this.h1Text = "You have successfully unsubscribed!";
            this.pText = "We will no longer send you promotional emails. But don't worry, we'll still let you know about your appointments, quotes, and other need-to-know information regarding your account.";
        } else {
            this.h1Text = "An error has occurred!";
            this.pText = "Something went wrong while unsubscribing. Please contact us, and we'll be happy to manually unsubscribe you!";
        }
    } // responseCode()

    unsubscribeUser() {
        let params = {email: this.email};
        this.userService.unsubscribe(params)
            .subscribe(
                (result: any) => {
                    this.contentLoaded = true;

                    if (result.responseCode == 100) {
                        this.responseCode(true);
                        let trackParams = {
                            type: USER_EVENT_TYPE.UNSUBSCRIBE.value,
                            name: USER_EVENT_TYPE.UNSUBSCRIBE.label,
                            ga: {action: 'unsubscribe from marketing emails', properties: {category: "email unsubscribe", label: "success"}},
                            internal: {
                                endpoint: '/user/unsubscribe',
                                endpointParams: params
                            }
                        };
                        this.eventTrackingService.trackEvent(trackParams);
                    } else {
                        this.responseCode(false);
                        let trackParams = {
                            type: USER_EVENT_TYPE.UNSUBSCRIBE.value,
                            name: USER_EVENT_TYPE.UNSUBSCRIBE.label,
                            ga: {action: 'unsubscribe from marketing emails', properties: {category: "email unsubscribe", label: "error - response code not 100"}},
                            internal: {
                                endpoint: '/user/unsubscribe',
                                endpointParams: params
                            }
                        };
                        this.eventTrackingService.trackEvent(trackParams);
                    }

                },
                error => {
                    this.contentLoaded = true;
                    this.responseCode(false);
                    let trackParams = {
                        type: USER_EVENT_TYPE.UNSUBSCRIBE.value,
                        name: USER_EVENT_TYPE.UNSUBSCRIBE.label,
                        ga: {action: 'unsubscribe from marketing emails', properties: {category: "email unsubscribe", label: "error - response code not 100"}},
                        internal: {
                            endpoint: '/user/unsubscribe',
                            endpointParams: params
                        }
                    };
                    this.eventTrackingService.trackEvent(trackParams);
                }
            );
    } // unsubscribeUser()

}
